import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME
 } from '../../initials';
export class JumpFromDotToDotStartTopLeftEndBottomRight {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotStartTopLeftEndBottomRight',
            fromBallPositionByDot: BallPositionByDot.TOP_LEFT,
            toBallPositionByDot: BallPositionByDot.BOTTOM_RIGHT,
        };
    }

    getAnimationTime() {
        return JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, 3 * Math.PI / 4);
        const endXY = getNotCenteredCoordinateForAnimationByAngle(endDot.dotX, endDot.dotY, 7 * Math.PI / 4);

        return {
            x: parabolic(
                startXY.x, 
                isLeftMovement ? startXY.x - distanceBetweenDots / 2 : startXY.x + distanceBetweenDots / 2, 
                endXY.x, 
                t,
            ),
            y: parabolic(
                startXY.y, 
                startXY.y - distanseBetweenLayers / 2, 
                endXY.y, 
                t,
            ),
        };
    };
};